import * as React from 'react';
import * as R from 'ramda';
import { Form, Text, FormValues, FormErrors, Select } from 'react-form';
import { BaseFormProps, BaseFormState } from '../../../interfaces';
import { ValidationService, OrganizationDataService } from '../../../services';
import { Organization } from '../../../models';
import { observer, inject } from 'mobx-react';
import { ServiceStore } from '../../../stores';

interface FormProps extends BaseFormProps {
    ServiceStore?: ServiceStore;
}

interface FormState extends BaseFormState {
    organizations: Organization[];
}

@inject('ServiceStore') @observer
export class ScoreCardForm extends React.Component<FormProps, FormState> {
    private vs = new ValidationService();
    private organizationDataService: OrganizationDataService;

    constructor(props: BaseFormProps) {
        super(props);

        this.state = {
            canSubmit: true,
            formErrors: {},
            organizations: []
        };

        this.props.defaultValues.surveyReportTypes = this.props.defaultValues.surveyReportTypes || [];

        this.organizationDataService = new OrganizationDataService(this.props.ServiceStore!.notificationService);

        this.validateErrors = this.validateErrors.bind(this);
        this.validateSuccess = this.validateSuccess.bind(this);
    }

    componentDidMount() {
        this.organizationDataService.getAll().then((orgs: Organization[]) => {
            this.setState({ organizations: orgs });
        });
    }

    // Validation methods
    validateErrors(values: FormValues) {
        const { name, organizationID } = values;
        let formErrors: any = {};

        if (name || name === '') {
            if (!this.vs.required(name)) {
                formErrors.name = 'Name is required.';
            } else if (!this.vs.cannotBeEmpty(name!)) {
                formErrors.name = 'Name cannot be blank.';
            }
        }

        if (organizationID) {
            if (!this.vs.required(organizationID)) {
                formErrors.organizationID = 'Organization is required.';
            }
        }

        return formErrors;
    }

    validateSuccess(values: FormValues, errors: FormErrors) {
        if (R.isEmpty(errors)
        && this.vs.validateRequiredFieldsExist(['name', 'organizationID'], values)
        ) {
            this.setState({ canSubmit: true, formErrors: errors });
        } else {
            this.setState({ canSubmit: false, formErrors: errors });
        }

        return errors;
    }
    // end of validation stuff

    public render() {
        const { canSubmit, formErrors } = this.state;
        
        const organizationOptions = !this.state.organizations ? [] : this.state.organizations.map((organization) => {
            return {
                label: organization.name,
                value: organization.id
            };
        });

        return (
            <Form
                defaultValues={this.props.defaultValues}
                onSubmit={submittedValues => this.props.submit(submittedValues)}
                validateError={this.validateErrors}
                validateSuccess={this.validateSuccess}
            >
                {formApi => (
                    <form onSubmit={formApi.submitForm} id="entityForm">
                        <div className="form-group">
                            <label htmlFor="name">Name *</label>
                            <Text className="form-control" field="name" id="name" />
                            {formErrors.name && <span className="help-block error-text">{formErrors.name}</span>}
                        </div>
                        <div className="form-group">
                                <label htmlFor="organizationID">Organization *</label>
                                <Select className="form-control" field="organizationID" id="organizationID" options={organizationOptions} />
                                {formErrors.organizationID && <span className="help-block error-text">{formErrors.organizationID}</span>}
                            </div>

                        <button type="submit" className="btn btn-primary" disabled={!canSubmit}>Save</button>
                    </form>
                )}
            </Form>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/scoreCard/scoreCard/ScoreCardForm.tsx